(() => {
  if (!document.documentElement || document.documentElement.dataset.template !== 'index') return;

  const VIDEO_SELECTOR = 'video.wn-video-shop__video';
  const seen = new WeakSet();

  function stashSource(source) {
    if (!source || source.dataset.wnSrc) return;
    const src = source.getAttribute('src');
    if (!src) return;
    source.dataset.wnSrc = src;
    source.removeAttribute('src');
  }

  function freezeVideo(video) {
    if (!video || !video.matches || !video.matches(VIDEO_SELECTOR)) return;

    video.autoplay = false;
    video.removeAttribute('autoplay');
    video.preload = 'none';
    video.muted = true;
    video.playsInline = true;
    video.dataset.wnLazyVideo = 'true';

    const directSrc = video.getAttribute('src');
    if (directSrc && !video.dataset.wnSrc) {
      video.dataset.wnSrc = directSrc;
      video.removeAttribute('src');
    }

    video.querySelectorAll('source').forEach(stashSource);

    try { video.pause(); } catch (_) {}
    try { video.load(); } catch (_) {}

    if (seen.has(video)) return;
    seen.add(video);

    if (!('IntersectionObserver' in window)) return;

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const el = entry.target;
        if (entry.isIntersecting) {
          if (el.dataset.wnHydrated !== 'true') {
            if (el.dataset.wnSrc) {
              el.setAttribute('src', el.dataset.wnSrc);
            }
            el.querySelectorAll('source[data-wn-src]').forEach((source) => {
              source.setAttribute('src', source.dataset.wnSrc);
            });
            el.dataset.wnHydrated = 'true';
            el.preload = 'metadata';
            try { el.load(); } catch (_) {}
          }
          const playPromise = el.play();
          if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
        } else if (el.dataset.wnHydrated === 'true') {
          try { el.pause(); } catch (_) {}
        }
      });
    }, { rootMargin: '220px 0px', threshold: 0.01 });

    io.observe(video);
  }

  function inspectNode(node) {
    if (!node || node.nodeType !== 1) return;

    if (node.matches && node.matches(VIDEO_SELECTOR)) {
      freezeVideo(node);
    }

    if (node.matches && node.matches('source') && node.parentElement && node.parentElement.matches(VIDEO_SELECTOR)) {
      stashSource(node);
      freezeVideo(node.parentElement);
    }

    if (node.querySelectorAll) {
      node.querySelectorAll(VIDEO_SELECTOR).forEach(freezeVideo);
      node.querySelectorAll(`${VIDEO_SELECTOR} source`).forEach((source) => {
        stashSource(source);
        freezeVideo(source.parentElement);
      });
    }
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach(inspectNode);
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(VIDEO_SELECTOR).forEach(freezeVideo);
  }, { once: true });
})();
